import { LazyImage } from '@components/common/image'
import { QUIZZES_IMAGE_PATH } from '@lib/constants/quizzes'
import { animated } from '@react-spring/web'
import { SpringValue } from '@react-spring/core'
import { useEffect, useMemo } from 'react'
import { Line } from 'rc-progress'

type Props = {
  attemptedProblemCount: number
  currentPoints: number
  totalProblems: number
}

const ProblemStatusBar = ({
  attemptedProblemCount,
  totalProblems,
  currentPoints,
}: Props) => {
  const animatedPoints = useMemo(() => new SpringValue(currentPoints), [])

  useEffect(() => {
    animatedPoints.update({ to: currentPoints }).start()
  }, [currentPoints])

  return (
    <div className="flex flex-col lg:flex-row justify-between px-5 py-2 lg:pt-0 space-y-3">
      <div className="flex items-center space-x-3 w-full lg:w-80">
        <p className="whitespace-no-wrap font-600">
          Q {attemptedProblemCount}/{totalProblems}
        </p>
        <Line
          percent={(attemptedProblemCount * 100) / totalProblems}
          trailWidth={4}
          strokeWidth={4}
          strokeColor="#4ABC96"
          trailColor="#C3EDF5"
          strokeLinecap="round"
          className="h-3 lg:h-auto w-full"
        />
      </div>
      <div className="flex justify-end">
        <div className="flex items-center space-x-3">
          <LazyImage
            path={`${QUIZZES_IMAGE_PATH}arena/`}
            name="points"
            alt="a hand with stars"
            className="w-8"
          />
          <p className="font-600">
            Points:{' '}
            <animated.span>
              {animatedPoints.to((points) => points.toFixed())}
            </animated.span>
          </p>
        </div>
      </div>
    </div>
  )
}

export default ProblemStatusBar
